import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget"
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext"
import PoleCreateUpdateFormPresenter from "../../../../features/planBT/components/Pole/PoleCreateUpdateForm/PoleCreateUpdateFormPresenter"


export default function CreatePolePage() {
  const {navigate} =useMicroNavigator()
  return (
  
    <div style={{color: 'white'}}>
       <HeaderWidget  withBackBtn handleBackBtn={() => navigate('list')} variant="dark">Nouveau Poteaux</HeaderWidget>
       <PoleCreateUpdateFormPresenter  variant="dark"/>
    </div>
  )
}
